/* eslint-disable */ 
const topMenulinks = document.querySelectorAll('.top-menu-link');
const banner = document.querySelector('.banner');
const menuPrimary = document.querySelectorAll('#menu-primary > li');
const btnAdherent = document.querySelector('.btn-adherant');
const brand = document.querySelector('.brand');
const brandWhite = document.querySelector('.brand-white');
const xIcon = document.querySelector('.desktop-x-icon');
const body = document.querySelector('body');
const closeBtn = xIcon.querySelector('a');


const element = document.createElement('div');
element.classList.add('container', 'menu-grid-wrapper');

const verticalLine = document.createElement('div');
verticalLine.classList.add('vertical-line');


const searchNavIcon = document.querySelector('#search-icon-desktop');

searchNavIcon.parentNode.onclick = function() {

  menuPrimary.forEach( el => el.classList.add('hidden'))
 





  body.classList.add('no-scroll');
  brand.style.display = "none";
  brandWhite.style.display = "block";
  xIcon.classList.add('show-x-icon');
  banner.classList.add('green-banner');
  body.style.backgroundColor = "#00725A";
  btnAdherent.style.display = "none";

  closeBtn.onclick = () => {
    body.classList.remove('no-scroll');
    brandWhite.style.display = "none";
    brand.style.display = "block";
    body.style.backgroundColor = "unset";
    btnAdherent.style.display = "block";
    xIcon.classList.remove('show-x-icon');
    banner.classList.remove('green-banner');
    searchFormWrapper.classList.remove('form-active');
    menuPrimary.forEach( el => el.classList.remove('hidden'));
  }
}

topMenulinks.forEach( el => {

  el.onclick = (item) => {

    const parentEl =  item.target.parentNode.parentNode;
    const container = parentEl.insertBefore(element, parentEl.firstChild);
    const menuTitle = parentEl.querySelector('ul.sub-menu > li:first-child');
    const subMenu = parentEl.querySelector(' ul.sub-menu');

    

    console.log(parentEl);

    menuTitle.appendChild(verticalLine);
    container.appendChild(menuTitle);
    container.appendChild(subMenu);



    menuPrimary.forEach( el => {
      if (el != parentEl)
        el.classList.add('hidden');
    })

    body.classList.add('no-scroll');
    body.style.backgroundColor = "#00725A";
    subMenu.style.display = "block";
    brand.style.display = "none";
    brandWhite.style.display = "block";
    xIcon.classList.add('show-x-icon');
    banner.classList.add('green-banner');
    btnAdherent.style.display = "none";
    parentEl.classList.add('fullscreen-menu');


    closeBtn.onclick = () => {


      const subMenuNext = parentEl.querySelector('.container > ul.sub-menu');

      subMenuNext.insertBefore(menuTitle, subMenuNext.firstChild);
      parentEl.appendChild(subMenuNext);
      parentEl.removeChild(container);

     

      body.classList.remove('no-scroll');
      body.style.backgroundColor = "unset";
      subMenu.style.display = "none";
      brandWhite.style.display = "none";
      brand.style.display = "block";
      btnAdherent.style.display = "block";
      xIcon.classList.remove('show-x-icon');
      banner.classList.remove('green-banner');
      parentEl.classList.remove('fullscreen-menu');

      menuPrimary.forEach( el => {
        if (el.classList.contains('hidden'))
          el.classList.remove('hidden');
      })

    }
  }
})



  const searchIcon = document.querySelector('#search-icon-desktop');
  var searchFormWrapper = document.querySelector('.navbar > .search-form-wrapper');
  // const closeSearchForm = document.querySelector('.navbar .close-searchform-icon');
  const submitSearchIcon = document.querySelector('.navbar .submit-search-icon');
  // prevent page scroll on click
  searchIcon.parentNode.setAttribute('href', 'javascript:void(0)');

  searchIcon.onclick = () => searchFormWrapper.classList.add('form-active')

  submitSearchIcon.onclick = function() {
    document.querySelector('.navbar .searchform > input[type="submit"]').click();
  }




// WEBPACK FOOTER //
// ./scripts/menu.js